<template>
  <div class="container">
    <div style="margin-bottom: 1rem">
      <el-row>
        <content-title :nav="nav"></content-title>
      </el-row>
          <el-descriptions title="设备投资人">
      <el-descriptions-item label="合作商">{{
        cooperator.title
      }}</el-descriptions-item>
      <el-descriptions-item label="联系人">{{
        cooperator.name
      }}</el-descriptions-item>
      <el-descriptions-item label="电话">{{
        cooperator.phone
      }}</el-descriptions-item>
       <el-descriptions-item label="账户余额">￥<span style="font-weight:600;">{{
        cooperator.account 
      }}</span></el-descriptions-item>
      <el-descriptions-item label="类型">
        {{coopWapMap[cooperator.coop_way] || ''}}
      </el-descriptions-item>
      <el-descriptions-item label="地址">{{
        cooperator.address
      }}</el-descriptions-item>
      <el-descriptions-item label="介绍">
        {{ cooperator.introduction }}
      </el-descriptions-item>
      <el-descriptions-item label="介绍图片">
        <div class="flex" v-if="cooperator.introduction_img">
          <el-image
            v-for="(pic, i) in cooperator.introduction_img.split(',')"
            :key="i"
            style="width: 100px; height: 100px"
            :src="pic"
          ></el-image>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    </div>

    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="方案" name="plan">
        <planList ref="plan"></planList>
      </el-tab-pane>
      <el-tab-pane label="设备" name="device">
        <deviceList ref="device"></deviceList>
      </el-tab-pane>
      <el-tab-pane label="流程进度" name="stage">
        <stage :cooperator="cooperator" ref="stage"></stage>
      </el-tab-pane>

      
    </el-tabs>
  </div>
</template>
  
<script>
import deviceList from "./components/deviceList/deviceList.vue";
import planList from "./components/planList/planList.vue";
import stage from './components/stage/stage.vue';
export default {
  components: {
    deviceList,
    planList,
    stage
  },
  data() {
    return {
      id: "",
      nav: { firstNav: "投资方", secondNav: "详情" },
      cooperator: {},
      activeName: "plan",
      coopWapMap:{
        revenue:'收益合作',
        strategy:'战略合作'
      }
    };
  },
  methods: {
    tabClick(v) {
      this.$refs[v.name].init();
    },
    getDetails() {
      let url = "/user/cooperator/findById";
      this.$axios
        .get(url, {
          params: {
            id: this.id,
          },
        })
        .then((res) => {
          this.cooperator = res.data.data;
           
        });
    },
  },
  mounted() {
    this.id = this.$route.query.cid;
    this.getDetails();
   this.$nextTick(() => {
            this.$refs[this.activeName].init();
         });
  },
};
</script>
  
<style></style>
  